export default __webpack_public_path__ + "static/media/Mariachis.c6331eda.mp3";